<template>
    <vue-scroll :ops="$ops" style="max-height:700px">
        <div class="table-responsive" style="clear: both;">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>合同</th>
                    <th>学期</th>
                    <th>余额</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in $parentInfo.studentWallet.dialog_BalanceDetail.balanceDetails">
                    <td>{{item.invoice_id}}</td>
                    <td>{{item.semester_name}}</td>
                    <td>{{item.balance}}</td>
                    <td>
                        <el-button type="primary" @click="handleInvoiceRefund(item.invoice_id)">退款</el-button>
                    </td>
                </tr>
                </tbody>
            </table>

            <el-dialog
                    title="退款详情"
                    :visible.sync="$parentInfo.studentWallet.dialog_BalanceDetail.showInvoiceRefund"
                    width="30%"
                    :modal=false>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>退款编号</th>
                        <th>退款方式</th>
                        <th>已退金额</th>
                        <th>本次退款</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in $parentInfo.studentWallet.dialog_BalanceDetail.invoiceRefunds">
                        <td>{{item.name}}</td>
                        <td v-if="item.refund_type==='pos'"><img :src="item.url" alt=""
                                                                 style="width: 30px"></td>
                        <td v-else>{{item.url}}</td>
                        <td>{{item.hasRefund}}</td>
                        <td>
                            <el-input v-model="item.refund" size="small" style="width:100px"></el-input>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="text-right">
                    <el-button @click="$parentInfo.studentWallet.dialog_BalanceDetail.showInvoiceRefund = false">取消
                    </el-button>
                    <el-button type="primary" size="small" @click="handleRefund()"
                               :loading="$parentInfo.studentWallet.dialog_BalanceDetail.loading">提交
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </vue-scroll>
</template>

<script>
    export default {
        name: "Dialog_BalanceDetail",
        data() {
            return {
                invoice_id: 0,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInvoiceBill();
        },
        methods: {
            handleInvoiceBill() {
                this.$wApi.send(this.$parentInfo.path, 'get_balanceDetail', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleInvoiceRefund(invoice_id) {
                this.invoice_id = invoice_id;
                this.$parentInfo.studentWallet.dialog_BalanceDetail.showInvoiceRefund = true;
                this.$wApi.send(this.$parentInfo.path, 'get_invoiceRefund', {
                    'invoice_id': invoice_id,
                });
            },
            handleRefund() {
                this.$parentInfo.studentWallet.dialog_BalanceDetail.loading = true;
                this.$confirm('确定提交?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'give_refund_to_student', {
                        'toRefund': this.$parentInfo.studentWallet.dialog_BalanceDetail.invoiceRefunds,
                        'invoice_id': this.invoice_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            }
        }
    }
</script>

<style scoped>

</style>